import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import { LoaderCircle } from 'lucide-react'

/**
 * Figma (node 18665:25955): Uses Lucide LoaderCircle icon.
 * Sizes: 3 (12px), 4 (16px), 5 (20px), 6 (24px), 8 (32px).
 * Container: flex items-center justify-center, animate-spin.
 */
const spinnerVariants = cva('animate-spin text-muted-foreground', {
  variants: {
    size: { sm: 'h-3 w-3', md: 'h-4 w-4', default: 'h-5 w-5', lg: 'h-6 w-6', xl: 'h-8 w-8' },
  },
  defaultVariants: { size: 'default' },
})

export interface IntuiSpinnerProps extends VariantProps<typeof spinnerVariants> {
  label?: string
  className?: string
}

function IntuiSpinner({ size, label, className }: IntuiSpinnerProps) {
  return (
    <div className={cn('inline-flex items-center gap-2', className)} role="status" aria-label={label ?? 'Loading'}>
      <LoaderCircle className={cn(spinnerVariants({ size }))} />
      {label && <span className="text-sm text-muted-foreground">{label}</span>}
      {!label && <span className="sr-only">Loading</span>}
    </div>
  )
}

export { IntuiSpinner, spinnerVariants }
